import React from 'react';
import { HStack, Text } from '@gluestack-ui/themed';
import { useAuthStore } from '../../../auth/store';
import UserMenuComponent from '../../components/UserMenu';
import JobStatusIcon from '../../components/JobStatusIcon';

/**
 * Header component for the right side of the Lecturer navigation bar.
 * Displays the user's name and the UserMenu.
 */
const LecturerHeaderRight: React.FC = () => {
  const logout = useAuthStore((state) => state.logout);
  const user = useAuthStore((state) => state.user);
  const displayName = user ? `${user.firstname || ''} ${user.lastname || ''}`.trim() : '';

  return (
    <HStack alignItems="center" space="md">
      {!!displayName && (
        <Text fontSize={13} color="$textSubtle" fontWeight="medium">
          {displayName}
        </Text>
      )}
      <JobStatusIcon />
      <UserMenuComponent user={user} logout={logout} placement="bottom right" />
    </HStack>
  );
};

export default LecturerHeaderRight;
